import { Command, ICommandShortcut } from '@Common/ApplicationCore/Command';
import { commandGroups } from '@Common/ApplicationCore/CommandGroups';
import { commands } from '@Common/ApplicationCore/Commands';

export default class CommandProvider {
    private readonly commandById: Map<string, Command>;
    private readonly commandByShortcut: Map<string, Command>;
    private readonly groupNameByCommand: Map<string, string>;

    constructor(
        allCommands: Record<string, Command> = _.cloneDeep(commands),
        private readonly groups: { name: string; items: Command[] }[] = _.cloneDeep(commandGroups)
    ) {
        this.commandById = new Map(Object.values(allCommands).map(c => [c.id, c]));
        this.commandByShortcut = new Map(
            Object.values(allCommands)
                .filter(command => command.shortcut)
                .map(command => [getKeyFromShortcut(command.shortcut, command.globalShortcut), command])
        );
        this.groupNameByCommand = new Map(groups.flatMap(g => g.items.filter(Boolean).map(cmd => [cmd.id, g.name])));
    }

    public getToolbarGroups(): { name: string; items: (Command | null)[] }[] {
        return _.cloneDeep(this.groups);
    }

    public getCommand(commandId: string, throwable: boolean = true): Command {
        const command = this.commandById.get(commandId);
        if (throwable && !command) {
            throw new Error(`Command with id = '${commandId}' not found`);
        }

        return command;
    }

    public getCommandByShortcut(e: Partial<JQuery.Event>, globalCommands?: boolean): Command | null {
        const key: string = getKeyFromShortcut(e, globalCommands);
        return this.commandByShortcut.get(key) ?? null;
    }

    public getCommandGroupName(id: string): string {
        return this.groupNameByCommand.get(id);
    }
}

function getKeyFromShortcut(shortcut: ICommandShortcut | Partial<JQuery.Event>, globalCommands?: boolean): string {
    const code = 'which' in shortcut ? shortcut.which : shortcut.keyCode;
    const { altKey = false, ctrlKey = false, shiftKey = false } = shortcut;
    const prefix = [globalCommands && 'Global', altKey && 'Alt', ctrlKey && 'Ctrl', shiftKey && 'Shift']
        .filter(Boolean)
        .concat(code.toString())
        .join('+');
    return prefix;
}
